import { Button } from '@/components/ui/button';
import { ArrowRight } from '@phosphor-icons/react';

export const AboutSection = ({ onGetStarted }) => {
  return (
    <section id="about" className="py-24 px-6 bg-[#FAFAFA]">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="font-heading text-4xl md:text-5xl font-bold tracking-tight text-[#09090B] mb-6">
              Join the Community
            </h2>
            <p className="text-lg text-[#71717A] mb-6">
              DashLink Gaming brings together players from around the world. Whether you&apos;re a casual gamer 
              or a competitive pro, our platform provides the tools you need to connect, compete, and grow.
            </p>
            <p className="text-lg text-[#71717A] mb-8">
              With real-time chat, live streaming integration, voice notes, and comprehensive leaderboards, 
              you&apos;ll always be at the center of the action.
            </p>
            <Button 
              onClick={onGetStarted}
              className="bg-[#0047FF] hover:bg-[#0037CC] text-white"
            >
              Join Now - It&apos;s Free
              <ArrowRight size={18} className="ml-2" />
            </Button>
          </div>
          <div className="relative">
            <img 
              src="https://images.unsplash.com/photo-1511512578047-dfb367046420?w=600&h=500&fit=crop"
              alt="Gaming Community"
              className="w-full shadow-xl"
            />
            <div className="absolute -bottom-8 -left-8 bg-[#0047FF] p-6 text-white">
              <p className="font-mono text-4xl font-bold">100%</p>
              <p className="text-sm opacity-80">Free to play</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
